export { default as translations } from './translations.json';

export const DOC_TYPES = ['business_license', 'certification', 'insurance', 'id_document', 'other'];
export const DOC_STATUSES = ['pending', 'approved', 'rejected'];

/**
 * Get verification documents from user.
 * @param {Object|null} user
 * @returns {Object[]}
 */
export const getVerificationDocs = (user) =>
  user?.attributes?.metadata?.verificationDocs || [];

/**
 * Check if user has any approved document.
 * @param {Object|null} user
 * @param {string} [type] — optional: specific type
 * @returns {boolean}
 */
export const hasApprovedDoc = (user, type) => {
  const docs = getVerificationDocs(user);
  return docs.some(d => d.status === 'approved' && (!type || d.type === type));
};
